import DailyList from './DailyList';

export default DailyList;